import { render, staticRenderFns } from "./BusinessMenuModal.vue?vue&type=template&id=72e8c9b2&scoped=true&"
import script from "./BusinessMenuModal.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuModal.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuModal.vue?vue&type=style&index=0&id=72e8c9b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8c9b2",
  null
  
)

export default component.exports